import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * コンテンツ取得API
 */
export namespace ApiTaCt020 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        pieceId: string // 学習コマID
        unitId: string // 配信単位ID
        contentId?: string[] // 学習コンテンツID
      }
    }

    // API Response
    interface ContentNode {
      contentId: string // 学習コンテンツID
      name: string // コンテンツ名称
      questionNo: number // コンテンツ問題番号
      contentUrl: string // コンテンツURL
      contentType: string // コンテンツ分類
      sortNo: number // 表示順
      point: number // 配点
      status: string // 正誤判定結果
      isLastQuestion: boolean // 最終問題フラグ（0:最終問題ではない, 1:最終問題である）
      contentCategory: number // コンテンツカテゴリ
    }
    export interface Response {
      deliveryYear: number // 学習年
      deliveryMonth: number // 学習月
      productId: string // 商品ID
      nameDisp: string // 学習コマ名称
      pieceTypeId: string // 学習コマ区分
      pieceStudiedFlg: number // 学習コマ取組みフラグ
      pieceLv: number // 学習コマレベル
      contents: ContentNode[] // 学習コンテンツ
    }

    // API Path
    export const path: string = '/ta/contentInfo'
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        deliveryYear: 0,
        deliveryMonth: 0,
        productId: '',
        nameDisp: '',
        pieceTypeId: '',
        pieceStudiedFlg: 0,
        pieceLv: 0,
        contents: [
          {
            contentId: '',
            name: '',
            questionNo: 0,
            contentUrl: '',
            contentType: '',
            sortNo: 0,
            point: 0,
            status: '',
            isLastQuestion: false,
            contentCategory: 0,
          },
        ],
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
